import { createContext } from 'react';
import { useMessages } from '@/hooks';

export type MessageContextType = {
  refresh: () => void;
  loading: boolean;
  messagesInbox: InboxMessageEntity[];
  unreadForceMessages: InboxMessageEntity[];
  markAsRead: (id: string | number) => Promise<any>
};

export const MessageContext = createContext<MessageContextType>({
  loading: false,
  messagesInbox: [],
  unreadForceMessages: [],
  markAsRead: null,
  refresh: null
});

export const MessageContextProvider = ({ children }) => {

  const {
    loading,
    markAsRead,
    messagesInbox,
    unreadForceMessages,
    refresh,
  } = useMessages();

  return (
    <MessageContext.Provider value={{
      refresh,
      loading,
      messagesInbox,
      unreadForceMessages,
      markAsRead
    }}>
      {children}
    </MessageContext.Provider>
  );
};
